import { styled } from "@mui/material";
import { Link } from "react-router-dom";

export const LinkStyleless = styled(Link)({
  color: "inherit",
  textDecoration: "none",
});
